import { axiosInstance } from ".."

const customerWallet = async (id) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/wallet/${id}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default customerWallet;